import { AppThunk } from "store";

import { applicationActions } from "../reducer";
import { TRouteCalculationLoadingStatus } from "entities/application/types";

export const setRouteCalculationLoadingStatus =
  (status: TRouteCalculationLoadingStatus): AppThunk =>
  async (dispatch) => {
    dispatch(applicationActions.setRouteCalculationLoadingStatus(status));
  };
